import {BaseProps} from "../../../infrastructure/models/props/base-props";
import {StandingsWidgetStageViewModel} from "../models/standings-widget.stage.view-model";

class StandingsWidgetMenuItemProps extends BaseProps {
  item: StandingsWidgetStageViewModel;
}

export const StandingsWidgetMenuItem = ({item}: StandingsWidgetMenuItemProps) => {
  return item.shortName || item.name;
};